module.exports = kolibriCoreAppGlobal.utils.validators;